$(function () {


    $(".selettore-anno").on("click", function (evt) {
        $(".anno-selezionato").html($(this).html());
    })

    $(".apri-selettore-anno").on("click", function (evt) {
        $(".storia-white-nav").toggleClass("hidden");
        $(".apri-selettore-anno svg").toggleClass("girato-180");
    });


    //GESTIONE SCROLL PRIMA FACCIATA

    var isScrolled = false;
    $(window).on("scroll", function () {
        if($(window).scrollTop() === 0) {
            isScrolled = false;
            $(".storia-white-nav").addClass("dt:hidden");
            $(".apri-selettore-anno").addClass("hidden");
        } else {
            if( isScrolled === false) {
                $(".storia-white-nav").removeClass("dt:hidden");
                $(".apri-selettore-anno").removeClass("hidden");
                scrollHero();
                isScrolled = true;
            }
        }
    })

    $(".bottone-scroll").on("click", function () {
        scrollHero();
    })

    function scrollHero () {
        window.scrollTo({
            top: $(window).height() - 30,
            left: 0,
            behavior: 'smooth'
          });
    }
})